// The filter bar for a technical view (guide 20.1). It edits the ONE filter
// object the page holds; the drawing, schedule, summary, tracking panel and
// exports all read that object, so nothing here filters anything itself.
// Each value shows its live count against the other active facets, and a
// facet with a single value is not shown at all.
import React from "react";
import { Button, Select } from "antd";
import { facetCounts, isEmptyFilter } from "./facets";
import { matchOption } from "components/SearchSelect/searchSelect";

const MANY = 12;

export default function FacetBar({ rows, filter, onChange, ctx, levelName }) {
  const facets = facetCounts(rows, filter, ctx);
  if (!facets.length) return null;
  const toggle = (key, value) => {
    const cur = new Set(filter[key] || []);
    if (cur.has(value)) cur.delete(value); else cur.add(value);
    onChange({ ...filter, [key]: cur.size ? [...cur] : null });
  };
  const label = (f, v) => (f.key === "levels" && levelName ? levelName(v) : f.key === "zones" ? `Zone ${Number(v) + 1}` : v);
  return (
    <div className="g-facets" role="group" aria-label="Filter the view">
      {facets.map((f) => (f.values.length > MANY ? (
        // A long facet (rooms, keynotes on a big job) is a searchable list, not
        // a wall of checkboxes that pushes the drawing off the screen.
        <fieldset key={f.key} className="g-facet g-facet-many">
          <legend>{f.label}</legend>
          <Select filterOption={matchOption} mode="multiple" size="small" allowClear showSearch aria-label={f.label} placeholder={`Any ${f.label.toLowerCase()} (${f.values.length})`}
                  style={{ minWidth: 220, maxWidth: "100%" }} maxTagCount="responsive" optionFilterProp="label"
                  value={filter[f.key] || []}
                  onChange={(vals) => onChange({ ...filter, [f.key]: vals.length ? vals : null })}
                  options={f.values.map((v) => ({ value: v.value, label: `${label(f, v.value)} (${v.count})`, disabled: v.count === 0 && !v.on }))} />
        </fieldset>
      ) : (
        <fieldset key={f.key} className="g-facet">
          <legend>{f.label}</legend>
          {f.values.map((v) => (
            <label key={v.value} className={v.on ? "is-on" : v.count === 0 ? "is-zero" : undefined}>
              <input type="checkbox" checked={v.on} onChange={() => toggle(f.key, v.value)} />
              {" "}{label(f, v.value)} <span className="g-tsub">({v.count})</span>
            </label>
          ))}
        </fieldset>
      )))}
      {!isEmptyFilter(filter) && (
        <Button size="small" type="link" onClick={() => onChange(Object.fromEntries(Object.keys(filter).map((k) => [k, null])))}>Clear filters</Button>
      )}
    </div>
  );
}
